import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.organizations.root,
    element: loadable(() => import('./pages/OrganizationsPage')),
  },
  {
    path: paths.organizations.details.documentsPreview,
    element: loadable(() => import('./pages/OrganizationDocumentPreviewPage')),
  },
  {
    path: paths.organizations.details.documentsViewer,
    element: loadable(() => import('./pages/OrganizationDocumentViewerPage')),
  },
  {
    path: paths.organizations.details.root,
    element: loadable(() => import('./pages/OrganizationDetailsPage')),
    children: [
      {
        path: paths.organizations.details.tab,
        element: <Outlet />,
        children: [
          {
            path: paths.organizations.details.vendorsTab.children.details,
            element: <Outlet />,
          },
        ],
      },
    ],
  },
  {
    path: paths.organizations.details.auditDetails,
    element: loadable(
      () => import('./pages/AuditDetailsPage/AuditDetailsPage')
    ),
  },
];
